import NextSection from "@components/About/NextSection";
import cx from "classnames";
import styles from "./FAQs.module.scss";
import Item from "./Item";
import Markdown from "@components/Markdown";
import _ from "lodash";
import { usePageContext } from "@providers/PageProvider";
import { roomPage } from "@utils/helper";

const components = {
  li: ({ children }: any) => {
    return (
      <div className="flex">
        <div className="px-2">{`•`}</div>
        <div>{children}</div>
      </div>
    );
  },
};
export default function FAQs() {
  const { pageData } = usePageContext();
  const FAQs = roomPage.formatFAQs(pageData);
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <NextSection className={cx(styles.titleSectionWrapper)} type="dark">
        <div className={cx(styles.titleSection)}>{_.get(FAQs, "title")}</div>
      </NextSection>
      <div className={cx(styles.slogan)}>{_.get(FAQs, "subtitle")}</div>
      <div className={cx(styles.itemsWrapper)}>
        {_.map(_.get(FAQs, "data", []), (item) => {
          return {
            title: _.get(item, "title"),
            content: (
              <Markdown
                content={_.get(item, "content")}
                components={components}
              />
            ),
            // sampleContent,
          };
        }).map((item, index) => (
          <Item key={index} data={item} />
        ))}
      </div>
    </div>
  );
}
